document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('new-ingredients-open-popup');
  const closeBtn = document.getElementById('new-ingredients-close-popup');
  const popup = document.getElementById('new-ingredients-popup');

  openBtn.addEventListener('click', function (e) {
    e.preventDefault();
    popup.style.display = 'flex';
  });

  closeBtn.addEventListener('click', function () {
    popup.style.display = 'none';
  });

  window.addEventListener('click', function (e) {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });
});